import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { applicationPaths, queryParameterNames } from '@shared/constants';
import { AuthorizeService } from '@shared/services/authorize.service';
import { tap } from 'rxjs/operators';

export const authorizeGuard: CanActivateFn =
  (
    _next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) => {
    const authorizeService = inject(AuthorizeService);
    const router = inject(Router);

    return authorizeService.isAuthenticated()
      .pipe(tap(isAuthenticated => {
        if (!isAuthenticated) {
          router.navigate(applicationPaths.loginPathComponents, {
            queryParams: {
              [queryParameterNames.returnUrl]: state.url,
            },
          });
        }
      }));
  };
